import React from "react";
import { createPortal } from "react-dom";
import { BsCloseButton, BsButton } from "./BsUI.jsx";

export const BsModal = ({ children, onClick }) =>
{
	return createPortal(
		<div
			className="modal fade show"
			style={{
				display: "block",
				backgroundColor: "rgba(0,0,0,0.5)",
			}}
			onClick={()=>onClick?.()}
		>
			{ children }
		</div>,
		document.body
	);
};

export const BsModalDialog = ({title, body, footer, onClose}) => {
	return (
		<BsModal>
			<div
				className="modal-dialog"
				onClick={(e) => e.stopPropagation()}// モーダル内部のクリックは閉じない
			>
				<div className="modal-content">
					<div className="modal-header">
						<div className="fs-3 fw-bold">{title}</div>
						<BsCloseButton onClick={onClose} />
					</div>
					<div className="modal-body">
						{body}
					</div>
					<div className="modal-footer">
						{footer}
					</div>
				</div>
			</div>
		</BsModal>
	);
};

export const BsYesNoDialog = ({title, body, onSubmit, onCancel, onClose, yes="Yes", no="No", hideNo=false}) => {
	const onClickSubmit = () => {
		onSubmit?.();
		onClose();
	};
	const onClickCancel = () => {
		onCancel?.();
		onClose();
	};

	return (
		<BsModalDialog
			title={title}
			body={body}
			footer={
				<div className="p-0 d-flex gap-1">
					<BsButton onClick={onClickSubmit} text={yes} />
					{!hideNo && <BsButton onClick={onClickCancel} text={no} />}
				</div>
			}
			onClose={onClickCancel}
		/>
	);
};
